<template>
  <div class="step step--humidity-interactive humidity-interactive humidity-process">

    <div class="humidity-interactive__text">
      <template v-if="humidityNumber < humidityEnd"><span v-html="$t('humidityIncrease.title')"></span></template>
      <template v-else><span v-html="$t('humidityIncrease.titleReady')"></span></template>
    </div>

    <div
        class="humidity-process__controls rounded-box"
    >
      <div class="humidity-process__numbers text-red-hat text-shadow"
           :class="{'humidity-process__numbers--green': humidityNumber > 30}"
      >
        {{ humidityNumber }} <span>%</span>
      </div>

      <vue-slider v-if="!showNativeRange" ref="slider" v-model="humidityNumber" :disabled="isDisabled" :height="27" :dotSize="48" :min="0" :max="58"/>

      <div v-if="showNativeRange" class="range-slider-wrap">
        <input type="range" class="range-slider" ref="rangeSlider" :min="0" :max="58" v-model="humidityNumber">
      </div>
    </div>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'
import { mapState } from 'vuex';
import isTouchScreen from '@/helpers/isTouchScreen'
import isIOS from '../../helpers/isIOS'
export default {
  name: 'StepHumidityIncrease',
  props: {},
  components: {
    VueSlider
  },
  data() {
    return {
      timeoutQuery: null,
      humidityNumber: 3,
      humidityEnd: 58,
      nextFired: false,
      isDisabled: false,
      showNativeRange: false
    }
  },
  mounted () {
    if (this.$gtm) {
      this.$gtm.trackEvent({
        'event': 'Event',
        'analytics_action': this.$store.state.step + '-mounted',
        'analytics_label': this.$store.state.step,
      })
    }
    if(this.$refs.rangeSlider !== undefined) {
      let value = (this.$refs.rangeSlider.value-this.$refs.rangeSlider.min)/(this.$refs.rangeSlider.max-this.$refs.rangeSlider.min)*100
      this.$refs.rangeSlider.style.background = 'linear-gradient(to right, #1377D3 0%, #22D313 ' + value + '%, #C4C4C4 ' + value + '%, #C4C4C4 100%)'
      this.$refs.rangeSlider.oninput = function() {
        let value = (this.value-this.min)/(this.max-this.min)*100
        this.style.background = 'linear-gradient(to right, #1377D3 0%, #22D313 ' + value + '%, #C4C4C4 ' + value + '%, #C4C4C4 100%)'
      };
    }
  },
  created () {
    // console.log('isTouchScreen()', isTouchScreen())
    // console.log('this.isBrowser(\'Chrome\')', this.isBrowser('Chrome'))
    // console.log('window.innerWidth > 1000 && window.innerHeight > 1000', window.innerWidth > 1000 && window.innerHeight > 1000)
    this.showNativeRange = this.isBrowser('Chrome') && isTouchScreen() && window.innerWidth > 1000 && window.innerHeight > 1000
    // console.log('this.showNativeRange', this.showNativeRange)
  },
  updated () {},
  methods: {
    next() {
      this.$emit('next')
    },

    humidityNumberMethod(val) {
      if(!isIOS()) {
        if(val < 15 && this.modelNum !== 2) {
          this.$store.commit('setModel', 2)

          if (this.$gtm) {
            this.$gtm.trackEvent({
              'event': 'Event',
              'analytics_action': this.$store.state.step + '-humidity-increase-step-1',
              'analytics_label': this.$store.state.step,
            })
          }
        }
        else if(val > 15 && val < 40 && this.modelNum !== 3) {
          this.$store.commit('setModel', 3)

          if (this.$gtm) {
            this.$gtm.trackEvent({
              'event': 'Event',
              'analytics_action': this.$store.state.step + '-humidity-increase-step-2',
              'analytics_label': this.$store.state.step,
            })
          }
        }
        else if (val > 40 && this.modelNum !== 4) {
          this.$store.commit('setModel', 4)

          if (this.$gtm) {
            this.$gtm.trackEvent({
              'event': 'Event',
              'analytics_action': this.$store.state.step + '-humidity-increase-step-3',
              'analytics_label': this.$store.state.step,
            })
          }
        }
      }
    }
  },
  watch: {
    humidityNumber (val) {
      if (this.timeoutQuery) { clearTimeout(this.timeoutQuery) }
      this.timeoutQuery = setTimeout(() => this.humidityNumberMethod(val), 200)

      if (val >= this.humidityEnd) {
        this.humidityNumber = this.humidityEnd
        this.isDisabled = true
        if(!this.nextFired) {
          this.nextFired = true
          setTimeout(() => {
            if (this.$gtm) {
              this.$gtm.trackEvent({
                'event': 'Event',
                'analytics_action': this.$store.state.step + '-humidity-increase-done',
                'analytics_label': this.$store.state.step,
              })
            }
            this.next()
          }, 2000)
        }
      }
    },
  },
  computed: {
    ...mapState({
      step: state => state.step,
      modelNum: state => state.model
    })
  }
}
</script>

